export default {
      id: "ic-drag-drop-red-usage",
      viewBox: "0 0 12 13",
      url: "/" + "images/icons.3.109.2.svg#ic-drag-drop-red-usage",
      toString: function () {
        return this.url;
      }
    }